// extracted by mini-css-extract-plugin
export default {"tab_style":"cost_tab_style__YWAix","city_years_wrapper":"cost_city_years_wrapper__-NMpw"};